<template>
    <div>
        <div class="simulator-box">
            <div class="card-panel">

                <div class="flex-row">
                    <div class="col-xs-12 col-sm">
                        <h2 class="simulator-title loaded" >
                            Configuração Previdência Oficial {{ ano }}
                        </h2>
                    </div>
                    <div class="col-xs-12 col-sm-3 right-align">
                        <a id="add-lead" class="btn-floating btn-default" @click.prevent="form({ano})" v-if="funcionario_cargo_id === 1">
                            <i class="large material-icons">add</i>
                        </a>
                    </div>
                </div>
                <table class="responsive-table bordered striped" v-if='previdencias_oficiais.length'>
                    <thead>
                        <tr>
                            <th>Valor do salário de contribuição</th>
                            <th>Alíquota de Pagamento</th>
                            <th  v-if="funcionario_cargo_id === 1">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in previdencias_oficiais" :key="`previdencia-oficial-${item.previdencia_oficial_id}`">
                            <td>
                                <template v-if="item.valor_minimo === null">
                                    Igual ou menor que {{ item.valor_maximo | dinheiro }}
                                </template>
                                <template v-else-if="item.valor_maximo == null">
                                    Acima de {{ item.valor_minimo | dinheiro }}
                                </template>
                                <template v-else>
                                    Entre {{ item.valor_minimo | dinheiro }} até {{ item.valor_maximo | dinheiro }}
                                </template>
                            </td>

                            <td>
                                <template v-if="item.valor_maximo == null">
                                    {{ item.aliquota }}% do teto
                                </template>
                                <template v-else>
                                    {{ item.aliquota }}% da renda
                                </template>
                            </td>
                            <td  width="100"  v-if="funcionario_cargo_id === 1">
                                <a @click.prevent="excluir(item, index)" href class="text-primary">
                                    <i class="material-icons">delete</i>
                                </a>

                                <a href @click.prevent="form(item, index)" class="text-primary">
                                    <i class="material-icons">edit</i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="grey-text">
                    Não há informações cadastradas.
                </div>
            </div>

            <div class="mt-2 right-align">
                <router-link class="btn btn-default" :to="{name: 'configuracoes'}">Concluir</router-link>
            </div>


            <modal :is-active.sync="modal_form" :title="titulo_modal">
                <form @submit.prevent="salvar(previdencia_selecionada)">
                    <div>
                        <div class="form-group">
                            <label>Modo da base de cálculo</label>

                            <div class="flex-row mb-2 mt-2">
                                <div class="col-xs-12 col-sm">
                                    <input name="metodo" type="radio" class="with-gap" v-model.number="metodo" value="1" id="metodo-1"/>
                                    <label for="metodo-1">Normal</label>
                                </div>
                                <div class="col-xs-12 col-sm">
                                    <input id="metodo-2" name="metodo" type="radio" class="with-gap" v-model.number="metodo" value="2"/>
                                    <label for="metodo-2">Menor que</label>
                                </div>
                                <div class="col-xs-12 col-sm">
                                    <input id="metodo-3" name="metodo" type="radio" class="with-gap" v-model.number="metodo" value="3"/>
                                    <label for="metodo-3">Acima de</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="flex-row">
                                <div class="col-xs-12 col-sm" v-if="metodo != 2">
                                    <label>
                                        {{ metodo == 3 ? 'Acima de' : 'Mínimo' }}
                                    </label>
                                    <money class="form-control validate" v-model="previdencia_selecionada.valor_minimo" placeholder="Valor mínimo" />

                                </div>
                                <div class="col-xs-2 col-sm" v-if="metodo != 3">
                                    <label>{{ metodo == 2 ? 'Menor que' : 'Máximo' }}</label>
                                    <money class="form-control" v-model="previdencia_selecionada.valor_maximo" placeholder="Valor máximo" />
                                </div>
                            </div>

                            <div class="flex-row">
                                <div class="col-xs-12 col-sm">
                                    <label>Alíquota</label>
                                    <input type="number" step="0.1" min="0" class="form-control" v-model.number="previdencia_selecionada.aliquota" placeholder="Alíquota">
                                </div>
                            </div>
                            <div class="right-align">
                                <button class="btn grey-light" type="button" @click="() => modal_form = false">Cancelar</button>
                                <button class="btn btn-default" type="submit">Salvar</button>
                            </div>
                        </div>
                    </div>
                </form>
            </modal>

        </div>
    </div>
</template>

<script>

import { api } from "@/helpers/api";

import Modal from "@/components/common/Modal/Base.vue";

import Auth from "@/store/auth";

import modal from "@/helpers/wm-modal"

export default  {


    components: { Modal },

    name: 'previdencia-oficial-form',


    async created() {

       await this.carregar();
    },


    computed: {
        ano() {
            return this.$route.params.ano;
        },

        titulo_modal() {
            return `${this.previdencia_selecionada.previdencia_oficial_id ? 'Editar' : 'Cadastrar'} previdência oficial`
        },

        usuario ()
        {
            return Auth.state.user;
        },

        funcionario () {
            return this.usuario.pessoa.funcionario;
        },

        funcionario_cargo_id() {
            return this.funcionario.funcionario_cargo_id;
        },
    },

    data() {

        return {
            metodo: 1,
            previdencias_oficiais: [],
            previdencia_selecionada: {},

            modal_form: false,
        }
    },

    methods: {

        async carregar() {

            const {data: {result: {data: previdencias_oficiais}}} = await api.get('previdencia-oficial', {params: {
                ano: this.ano
            }});

            this.previdencias_oficiais = previdencias_oficiais;
        },

        form(previdencia) {

            this.previdencia_selecionada = {...previdencia};

            this.metodo = 1;

            if (previdencia.valor_minimo === null){
                this.metodo = 2;
            } else if (previdencia.valor_maximo === null) {
                this.metodo = 3;
            }

            this.modal_form = true;
        },


        async excluir(previdencia_oficial, index)
        {

            const resultado = await modal.confirm({
                text: 'Confirma a exclusão desse item?'
            })

            if (! resultado) return;

            await api.delete(`previdencia-oficial/${previdencia_oficial.previdencia_oficial_id}`);

            this.previdencias_oficiais.splice(index, 1);
        },

        async salvar()
        {

            const previdencia = {...this.previdencia_selecionada};

            if (this.metodo == 2) {
                previdencia.valor_minimo = null;
            } else if (this.metodo == 3) {
                previdencia.valor_maximo = null;
            }


            if (previdencia.previdencia_oficial_id) {
                await api.put(`previdencia-oficial/${previdencia.previdencia_oficial_id}`, previdencia);
            } else {
                const {data: {result: {data: resultado}}} = await api.post('previdencia-oficial', previdencia);
                this.previdencias_oficiais.push(resultado)
            }



            this.modal_form = false

            this.carregar();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/previdencia-oficial/Form.vue